// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141228/js/" + chunkId + "." + {"44":"c78a2a8e","225":"56273a7d","481":"e5d35476","486":"7090e2d7","770":"1699454f"}[chunkId] + ".0.8314260610901266.chunk.js";
};